import { ProjectProps } from '@root/config/projects';
import Markup from '@root/src/common/markup/markup';
import Link from 'next/link';
import React from 'react';
import ImageGallery from 'react-image-gallery';
import Image from 'next/image';
import FormButton from '@root/src/common/button/button';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';

const Project: React.FC<ProjectProps> = props => {
    const router = useRouter();

    return (
        <div className="pb-12 mx-4 md:mx-12 lg-mx-20 xl:mx-40 relative">
            <span className="lg:hidden absolute text-[8rem] -bottom-8 -right-4 text-tan font-quas-stencil opacity-40 leading-tight">
                {props.projectNumber}
            </span>
            <div className="lg:flex">
                <div className="flex-1 w-full lg:min-w-[67%] lg:w-2/3 mr-12 relative">
                    <span className="hidden lg:inline absolute text-[14rem] -bottom-20 -right-32 text-tan font-quas-stencil opacity-40">
                        {props.projectNumber}
                    </span>
                    <ImageGallery
                        items={props.images}
                        additionalClass=""
                        showPlayButton={false}
                        showNav={true}
                        renderItem={item => {
                            return (
                                <div className="">
                                    <Image
                                        objectFit="cover"
                                        layout="intrinsic"
                                        width={1200}
                                        height={720}
                                        className="image-gallery-image rounded-3xl animated fadeIn"
                                        src={item.original}
                                    />
                                </div>
                            );
                        }}
                        renderLeftNav={onClick => {
                            return (
                                <a
                                    onClick={onClick}
                                    className="absolute hidden lg:block z-10 text-tan lg:left-[8rem] xl:left-[14rem] bottom-[-6rem] cursor-pointer opacity-40 hover:opacity-100"
                                >
                                    <FontAwesomeIcon size="4x" icon={faCaretLeft} />
                                </a>
                            );
                        }}
                        renderRightNav={onClick => {
                            return (
                                <a
                                    onClick={onClick}
                                    className="absolute hidden lg:block z-10 text-tan lg:right-[8rem] xl:right-[14rem] bottom-[-6rem] cursor-pointer opacity-40 hover:opacity-100"
                                >
                                    <FontAwesomeIcon size="4x" icon={faCaretRight} />
                                </a>
                            );
                        }}
                        renderThumbInner={item => {
                            return (
                                <div className="mx-2">
                                    <Image
                                        objectFit="cover"
                                        layout="intrinsic"
                                        width={150}
                                        height={100}
                                        className="image-gallery-image rounded-xl"
                                        src={item.original}
                                    />
                                </div>
                            );
                        }}
                    />
                </div>
                <div className="lg:w-1/2 mt-4 md:mt-12 lg:mt-0 items-center justify-center">
                    <Markup
                        className={
                            'text-tan text-4xl md:text-6xl mb-4 font-kg-medium text-center lg:text-right uppercase '
                        }
                        content={props.title}
                    />

                    <Markup
                        className={
                            'markdown-body text-white mb-10 px-4 md:px-0 lg:pl-12 xl:pl-32 text-center lg:text-right text-xs md:text-base '
                        }
                        content={props.description}
                    />
                    <div className="text-center lg:text-right mb-12 lg:mb-0">
                        <Link href="/projects">
                            <a className="text-tan text-xs md:sm font-kg-medium mb-4 inline-block mr-4">
                                <FormButton
                                    label="BACK TO OUR PROJECTS"
                                    extraClassName="text-tan border-tan"
                                    onClick={e => {
                                        e.preventDefault();
                                        router.push('/projects');
                                    }}
                                />
                            </a>
                        </Link>
                        {props.nextLink && (
                            <div className={'text-center font-kg-medium lg:text-right inline-block'}>
                                <FormButton
                                    label="VIEW THE NEXT PROJECT"
                                    extraClassName="text-tan border-tan"
                                    onClick={e => {
                                        e.preventDefault();
                                        router.push(props.nextLink);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Project;
